export enum NFT_TYPE {
  MINER_MOLE = 'minerMole',
  ARGO = 'argo',
}
